import { STORAGE_KEYS } from "../Constants/storageKeys";

/**
 * SSR-safe predicate: returns `true` only inside a live change-date /
 * change-time checkout (the localStorage marker is set by
 * `ChangeDateContinueClickAction`).
 *
 * Authoritative gate for every change-date-specific branch — including:
 *  - per-leg Total formula in `PrepareBookingSummaryAction`
 *  - credit / carry-over math in `ConfirmAddonsAction`
 *  - auto-POST + DELETE bypass in `PersistAddonsOnConfirmAction`
 *  - carry-over pre-select in `PreparePassengerForAddons` /
 *    `SyncAlreadyAddonsAction`
 *  - credit banner in `CreditToSelectAddons`
 *  - "NEW" tag rule in `ManageSeatingAndAddons`
 *  - modification-fee row gating in `PaymentReceipt`
 *
 * The marker is the only reliable signal because other atoms / fields
 * (e.g. `paymentSummary.payment.alreadyPaidAddonsAmount`) can be populated
 * by sibling flows (quick-exchange, upgrade, book-it-again) or carry stale
 * values from an aborted change-date session.
 */
export const isLiveChangeDateCheckout = (): boolean =>
    typeof window !== "undefined" &&
    window.localStorage.getItem(STORAGE_KEYS.CHANGE_DATE_FLOW) === "true";
